<template>
  <home-component />
</template>
<script>
import HomeComponent from "@/components/HomeComponent.vue";
export default {
  components: {
    HomeComponent,
  },
};
</script>
<style lang="scss">
input {
  margin: 0.2rem;
}
</style>
